/**
 * 检查变量类型
 * @param {any} arg 传入的变量
 * @return {String} 变量类型
 *
 * @example
 *  isType({}) -> Object
 */
export function isType (arg) {
  return Object.prototype.toString.call(arg).slice(8, -1)
}



// WEBPACK FOOTER //
// ./src/plugins/request/util.js